module.exports = __webpack_public_path__ + "img/price-icon4.d7579f54.png";